<p-table #dtAuto [value]="this.autorizacionesService.autorizacionesPersona()" [columns]="cols" responsiveLayout="scroll" [rows]="10"
         [globalFilterFields]="['nombres','descripcion','tipoPersona','telefono','email']"
         [paginator]="true" [rowsPerPageOptions]="[10,25,50]" [showCurrentPageReport]="true"
         [styleClass]="'p-datatable-sm'"
         currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} {{this.textCurrentPageTable==''?'':textCurrentPageTable}}"
         selectionMode="multiple" [rowHover]="true" dataKey="idPersona">
    <ng-template pTemplate="caption">
        <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 class="m-0">{{this.textCaption==''?'':textCaption}} registrados: ({{ this.autorizacionesService.autorizacionesPersona().length }})</h5>
            <span class="block mt-2 md:mt-0 p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="autorizacionFilter(dtAuto, $event)"
                                   placeholder="Buscar {{this.textCaption==''?'':textCaption.toLowerCase()}}..." class="w-full sm:w-auto"/>
                        </span>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <shared-loader [hidden]="!_showLoader"></shared-loader>
        <tr>
            <th pSortableColumn="nombres">Nombre completo
                <p-sortIcon field="nombres"></p-sortIcon>
            </th>
            <th pSortableColumn="tipoPersona">Tipo Persona
                <p-sortIcon field="tipoPersona"></p-sortIcon>
            </th>
            <th pSortableColumn="telefono">Teléfono
                <p-sortIcon field="telefono"></p-sortIcon>
            </th>
            <th pSortableColumn="email">Correo Electrónico
                <p-sortIcon field="email"></p-sortIcon>
            </th>
            <th pSortableColumn="descripcion">Descripción
                <p-sortIcon field="descripcion"></p-sortIcon>
            </th>
            <th>Operaciones</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-autorizacion>
        <tr>
            <td>
                {{ autorizacion.nombres }} {{ autorizacion.apellidos }}
            </td>
            <td>
                {{ autorizacion.tipoPersona }}
            </td>
            <td>
                {{ findContactoByTipo(autorizacion.contactos, 'TELEFONO_CELULAR')?.contacto }}
            </td>
            <td>
                {{ findContactoByTipo(autorizacion.contactos, 'EMAIL')?.contacto }}
            </td>
            <td>
                {{ autorizacion.descripcion == null ? 'N/A' : autorizacion.descripcion }}
            </td>
            <td>
                <div class="flex">
                    <p-button 
                        icon="pi pi-user" 
                        class="p-button-rounded mr-2"
                        [rounded]="true"
                        [outlined]="true"
                        (click)="onEditarPerfil(autorizacion)"
                        pTooltip="Editar Titular" severity="info"/>
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>

<app-editar-perfil
    [title]="'Editar Titular'"
    [usuarioDialog]="mostrarUsuarioDialog"
    [correoPersona]="correoPersona"
    [idTipoPersona]="idTipoPersona"
    (closeAndSaveDialogUser)="cerrarUsuarioDialog()"
    (onGuardarPerfil)="guardarCambiosPerfil($event)" 
    [editarPerfil]="false"
>
</app-editar-perfil>
